'use strict'

/**
 * Module AJAX
 */

const J_LOCATION_PRINT = '.j_ajaxloader_print'
const J_AJAX_LOADER_GIF = '.j_loader_gif'
const C_ERROR_CLASS = 'error'
const C_HIDDEN = 'hidden'

/*
 * Load une action d'un controlleur et insert le content dans la page web
 * Les paramètres à envoyer doivent-être de la forme { id: id }, etc.
 */
function loadAndPrintContent(paramsToSend) {
    // On affiche le gif de chargement
    let $location = $(J_LOCATION_PRINT)
    const action = $location.data('action') // On récupère le controller visé
    const $gif = $(J_AJAX_LOADER_GIF)

    $location.removeClass(C_ERROR_CLASS)

    if ($gif !== undefined) {
        $gif.removeClass(C_HIDDEN)
    }

    const posting = $.ajax({
        // On appel l'action du controlleur en lui passant les paramètres désirés
        type: 'POST',
        url: action,
        data: paramsToSend
    })

    posting.done(function (content) {
        // En cas de réussite, on ajoute le résultat au html
        // On cache le gif de chargement
        const $gif = $(J_AJAX_LOADER_GIF)
        if ($gif !== undefined) {
            $gif.addClass(C_HIDDEN)
        }
        $(J_LOCATION_PRINT).empty().append(content)
    })

    posting.fail(function () {
        // En cas d'échec on affiche une erreur
        // On cache le gif de chargement
        const $gif = $(J_AJAX_LOADER_GIF)
        if ($gif !== undefined) {
            $gif.addClass(C_HIDDEN)
        }

        $location = $(J_LOCATION_PRINT)

        $location.addClass(C_ERROR_CLASS)
        $location.empty().append($t('AJAXLOADERINTERNALERROR'))
    })
}

/*
 * Load une action d'un controller et execute une callback avec son content
 * Les paramètres à envoyer doivent-être de la forme { id: id }, etc.
 */
function loadAndExecuteCallBack(
    requestType,
    paramsToSend,
    sucessCallback,
    failCallback,
    action
) {
    // On affiche le gif de chargement
    const $gif = $(J_AJAX_LOADER_GIF)

    if ($gif !== undefined) {
        $gif.removeClass(C_HIDDEN)
    }

    const posting = $.ajax({
        // On appel l'action du controlleur en lui passant les paramètres désirés
        type: requestType,
        url: action,
        data: paramsToSend
    })

    posting.done(function (content) {
        // En cas de réussite, on ajoute le résultat au html
        // On cache le gif de chargement
        const $gif = $(J_AJAX_LOADER_GIF)
        if ($gif !== undefined) {
            $gif.addClass(C_HIDDEN)
        }
        if (content.TagScripts !== undefined && content.TagScripts != '') {
            try {
                eval(content.TagScripts)
            } catch (error) {
                console.error(error)
            }
        }
        sucessCallback(content)
    })

    posting.fail(function (content) {
        // on cache le gif de chargement
        const $gif = $(J_AJAX_LOADER_GIF)
        if ($gif !== undefined) {
            $gif.addClass(C_HIDDEN)
        }

        failCallback(content)
    })
}

export default {
    loadAndPrintContent: loadAndPrintContent,
    loadAndExecuteCallBack: loadAndExecuteCallBack
}
